import { Switch } from './switch';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';

export const TooltipSwitch = ({
  checked,
  setChecked,
  shortLabel,
  longLabel,
  dataTestId,
}: {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  shortLabel: string;
  longLabel: string;
  dataTestId?: string;
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        {/* Hack to better align the switch with the rest of the action row */}
        <TooltipTrigger className="vai-mt-1" data-testid={dataTestId}>
          <Switch
            checked={checked}
            onCheckedChange={() => setChecked(!checked)}
            label={shortLabel}
          />
        </TooltipTrigger>
        <TooltipContent>
          <p>{longLabel}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
